import React from 'react';
import './Icon.css';

export function Logo({ size }) {
  return (
    <svg
      width={size ? size : null}
      height={size ? size : null}
      className={size ? null : 'iconSvg'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.8637 11.529V9.73202L21.5209 9.73202C21.9216 9.73202 22.1446 10.1743 21.8947 10.4733L12.692 21.4821C11.8456 22.4945 10.1363 21.9232 10.1363 20.6278L10.1363 14.268H11.9948M14.8637 11.529C14.8637 13.0417 13.5792 14.268 11.9948 14.268M14.8637 11.529L14.8637 3.37222C14.8637 2.07684 13.1544 1.50548 12.308 2.51795L3.10533 13.5267C2.85539 13.8257 3.07838 14.268 3.47906 14.268L11.9948 14.268"
        strokeWidth="2"
        strokeLinejoin="round"
        className="inactiveIcon"
      />
    </svg>
  );
}
